/**
 * Expense settings (FT3-U10, FIN-FR-026/028).
 *
 * Exported as `EXPENSE_SETTINGS_ROUTES` for the wave's INT packet to spread into
 * the router; this packet does not own `router/index.ts` or the nav. Reading
 * needs `expense.policy.read` (`GET /expense-settings`); saving is offered only
 * to `expense.policy.manage` (`PUT /expense-settings`).
 */

import type { RouteRecordRaw } from 'vue-router'

import { EXPENSE_PERMISSIONS } from '@/modules/expense/permissions'

export const EXPENSE_SETTINGS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/expense/settings',
    name: 'expense-settings',
    component: () => import('@/modules/expense/settings/ExpenseSettingsView.vue'),
    meta: {
      titleKey: 'expense.routeTitles.settings',
      permission: EXPENSE_PERMISSIONS.policyRead,
    },
  },
]
